import Content from "~/components/Content";
import { Link } from "@remix-run/react";
import { Separator } from "~/components/ui/separator";
import Logo from "~/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-muted-foreground py-16 xl:py-48">
      <Content variant="narrow">
        <div className="flex flex-col items-center gap-8">
          <p>info@linkt.se</p>
          <Link to="/integritetspolicy" className="underline">
            Integritetspolicy
          </Link>
        </div>
        <Separator className="bg-muted-foreground/40 mt-16 mb-8" />
        <div className="self-stretch flex flex-col md:flex-row items-center justify-around gap-8">
          <Logo className="h-6 w-fit" />
          <p className="text-center">
            &copy; 2023 Lorem Ipsum. All rights reserved.
          </p>
        </div>
      </Content>
    </footer>
  );
}
